import { v4 as uuid } from 'uuid'

import { isValidUuid } from '~/behavior-tracking/utility/helpers'

let viewportId: string | null = null
const HOM_VIEWPORT_ID_SESSION_STORE_KEY = 'hom:viewport-id'

export function getViewportId(): string {
  if (viewportId) {
    return viewportId
  } else {
    const storedId = window.sessionStorage.getItem(HOM_VIEWPORT_ID_SESSION_STORE_KEY)
    viewportId = storedId !== null && isValidUuid(storedId) ? storedId : uuid()

    return viewportId
  }
}
